import React from 'react';
import { Instagram, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-luxury-black text-white py-16 px-6 border-t border-gray-800" data-id="element-80">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-81">
        <h2 className="text-2xl font-serif mb-2 tracking-wider" data-id="element-82">
          ALEXA BEAUTY
        </h2>
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-8" data-id="element-83">
          Brows And Lashes
        </p>

        <p className="font-serif italic text-gray-400 mb-10 text-lg" data-id="element-84">
          Belleza profesional con estilo.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center text-sm font-sans text-gray-300" data-id="element-85">
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-86">
            <Instagram className="w-5 h-5" data-id="element-87" />
            @alexabeauty
          </a>
          <span className="hidden sm:block text-gray-600" data-id="element-88">|</span>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-89">
            <Phone className="w-5 h-5" data-id="element-90" />
            +1 (555) 123-4567
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-800 w-full text-xs text-gray-500 font-sans" data-id="element-91">
          &copy; {new Date().getFullYear()} Alexa Beauty. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}